import {Component} from '@angular/core';
import {AbstractAction} from '../abstract-action';

@Component({
    selector: 'vui-link-action',
    templateUrl: './link-action.component.html',
    styleUrls: ['./link-action.component.scss']
})
export class LinkActionComponent extends AbstractAction {

}
